<template>
  <div class="modal fade slide-up" :id="modalId" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <div class="modal-header">
            <h5>{{ entityName }}</h5>
          </div>

          <div class="modal-body">
            <profession-form :data-user="dataUser"
                             :current-user="currentUser"
                             :availableServices="availableServices"
                             :availableHubs="allHubs"
                             :availableOccupations="availableOccupations"
                             :fieldNameAddition="modalId"
                             :is-manager="false"
                             :small="true"
                             :collapseHubs="false"
                             @change="onProfessionFormChange" />
          </div>

          <div class="line">
            <p class="line-color"></p>
          </div>

          <div class="modal-footer mt-10">
            <div class="col-md-6 text-left">
              <button type="button"
                      class="btn btn-default btn-cons"
                      aria-label="Close"
                      @click="dismiss">
                {{ $t("buttons.cancel") }}
              </button>
            </div>
            <div class="col-md-6 text-right">
              <button type="button"
                      class="btn btn-primary btn-cons"
                      @click="onValidate">
                {{ $t("buttons.validate") }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProfessionForm from '@/components/candidate/ProfessionForm'

export default {
  name: 'CandidateEntityModal',
  props: ['userEntity', 'modalId'],
  inject: ['$validator'],
  components: {
    ProfessionForm
  },
  data() {
    return {
      dataUser: null,
      selectedServices: [],
      selectedAffiliatedService: null
    }
  },
  created() {
    this.initDataUser();
  },
  mounted() {
    var self = this;
    $('#' + this.modalId).on('hidden.bs.modal', function (event) {
      self.dataUser = self.userEntity
    })
  },
  watch: {
    userEntity: {
      handler(){
        this.initDataUser();
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      allServices: 'users/allServices',
      allHubs: 'users/allHubs',
      manageableServices: 'users/manageableServices',
      manageableOccupations: 'users/manageableOccupations'
    }),
    availableServices() {
      return this.allServices || this.manageableServices
    },
    availableOccupations() {
      return this.manageableOccupations
    },
    entityName() {
      return this.dataUser.entity.name;
    },
    needsAffiliatedService() {
      return this.dataUser.resource_type == 'intern';
    },
  },
  methods: {
    initDataUser() {
      this.dataUser = Object.assign({}, this.userEntity);
    },
    onProfessionFormChange(value) {
      this.updateDataUser('resource_type', value.resource_type)
      this.updateDataUser('affiliated_service', value.affiliated_service)
      this.updateDataUser('services', value.services)
      this.updateDataUser('occupations', value.occupations)
    },
    updateDataUser(field, value) {
      let tempdataUser =  Object.assign({}, this.dataUser)
      tempdataUser[field] = value
      this.dataUser = tempdataUser
    },
    validUserEntity() {
      if (!this.needsAffiliatedService) {
        this.dataUser.affiliated_service = null
      }

      return this.dataUser
    },
    onValidate() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit('validate', this.validUserEntity());
          $(`#${this.modalId}`).modal('hide');
        }
      });
    },
    dismiss() {
      this.dataUser = this.userEntity;
      $(`#${this.modalId}`).modal('hide');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/entities/CandidateEntityModal.vue